import type { ThemeDefinition } from 'vuetify';

export const mainTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#006a68',
    secondary: '#4a6362',
    tertiary: '#4a607b',
    danger: '#ba1a1a',
    gray: '#7d7d7d',
    light: '#FBFBFB',
    hint: '#ececec',
    'gray-1': '#707070',
    main: '#1F2F49',
    white: '#ffffff',
    black: '#000000',
    background: '#fafdfc',
    outline: '#6f7978',
    filedBorder: '#3F72AF',
    'dark-gray': '#323639',
    'light-purple': '#9747FF',
    'light-pink': '#F5EDFF',
    'gray-border': '#7d7d7d',
    orange: '#FF9500',
    'card-border': '#E7E7E7',
    'black-900': '#010101',
    'black-800': '#1E1E1E',
    'black-600': '#575757',
    'black-400': '#8F8F8F',
    'yellow-500': '#F5B335',
    'gray-btn': '#465461',
    'gray-text': '#737373',
    'black-500': '#737373',
    'red-400': '#FAEBEB',
    'red-500': '#FFC8C8',
    'alert-text': '#CB4B0A',
    'gray-background': '#D9D9D9',
    'gray-chip': '#EAECF0',
    'light-grayish-blue': '#F8F9FA',
    'blue-500': '#EEF7FC',
    'gray-500': '#6D6D6D',
    'gray-300': '#EEEEEE',
    'placeHolder-text': '#ababab',
    'blue-700': '#004299',
    'blue-300': '#05DBF2',
    'blue-50': '#E5F1FF',
    'blue-75': '#BDDCF6',
    'blue-1': '#0583F2',
    'blue-2': '#004396',
    'blue-3': '#05DBF2',
    'blue-4': '#2A7DE1',
    error: '#FB2C36',
    'error-light': '#FFEFEF',
    'gray-2': '#EAECEF',
    'gray-3': '#465461',
    'black-200': '#C7C7C7',
    'blue-800': '#002C66',
    'black-300': '#ABABAB',
    'black-20': '#F5F5F5',
    'blue-text': '#465465',
    linkedin: '#0A66C2',
    facebook: '#0866FF',
    yellow: '#F5B335',
    themeIcon: '#E5F1FF',
    themeBtn: '#002C66',
    tabbyWidget: '#FFFFFF',
    hoverReviewCard: '#F4F4F4',
    reviewCard: '#FCFCFC',
    selectButton: '#F3F3F5',
    hoverButton: '#F2F2F2',
    selectButtonBorder: '#7f86a7ff',
    'red-100': '#FFBDC0',
    'warning-text': '#894B00',
    'warning-bg': '#FEFCE8',
    success: '#086C1F',
    'success-bg': '#BBECC2',
    'error-bg': '#FFEBE7',
  },
};
